import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function InfoIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-info-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95 0 0 8.95 0 20s8.95 20 20 20 20-8.95 20-20S31.05 0 20 0zm3.94 33.38h-7.91v-14.8h7.91v14.8zm-.71-20.03c-.72.68-1.79 1.03-3.23 1.03-2.87 0-4.31-1.3-4.31-3.89 0-2.58 1.44-3.87 4.31-3.87s4.31 1.29 4.31 3.87c0 1.22-.36 2.18-1.08 2.86z"
  })));
}